import moment from "moment";
import { useReducer } from "react";
import DiscountCodeContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {
  ICreateDiscountCode,
  ICreateDiscountCodeClients, ISendNotificationDiscountCodeClients,
  IUpdateDiscountCode,
} from "../../models/discount-code/request";
import { IDiscountCode } from "../../models/discount-code/response";
import { IDiscountCodeQuery } from "../../models/discount-code/query";
export interface IProps {
  children: React.ReactNode;
}
const DiscountCodeContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.discountCode.getAllDiscountCode(
          state.query
        );

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.discountCode.getDiscountCode(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IDiscountCode) => {
    // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
  };

  const createDiscountCode = async (request: ICreateDiscountCode) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.discountCode.createDiscountCode(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateDiscountCode = async (
    id: number,
    request: IUpdateDiscountCode
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.discountCode.updateDiscountCode(id, request);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };
  const getClientsByArea = async (areaId: number) => {

  };
  
  const getClientsByType = async (userType: string) => {

  };
  
  const deleteDiscountCode = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.discountCode.deleteDiscountCode(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const getClients = async (idCode: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.discountCode.getClients(
          idCode,
          state.query
        );
        

        dispatch({ type: "SET_CLIENT", payload: { clientsList: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const createDiscountCodeClient = async (
    request: ICreateDiscountCodeClients
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.discountCode.createDiscountCodeClients(request);
        getClients(request.discountCodeId);
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const sendNotificationDiscountCodeClient = async (
      id: number,
      request: ISendNotificationDiscountCodeClients
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "send" },
        });
        await EndPoints.discountCode.sendNotificationDiscountCode(id, request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "send" },
        });
      },
      throwException: true,
    });
  };

  const deleteDiscountCodeClient = async ( request: ICreateDiscountCodeClients) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.discountCode.deleteDiscountCodeClients(request);

        getClients(request.discountCodeId);
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IDiscountCodeQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.discountCode.exportExcel(
          {
            ...request,
            filters: state.query.filters ?? [],
          },
          state.query
        );
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `DiscountCodes-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  return (
    <DiscountCodeContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          getClients,
          setDetails,
          getClientsByArea,
          getClientsByType,
          sendNotificationDiscountCodeClient,
          createDiscountCode,
          updateDiscountCode,
          deleteDiscountCode,
          exportExcel,

          createDiscountCodeClient,
          deleteDiscountCodeClient,
          
          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </DiscountCodeContext.Provider>
  );
};

export default DiscountCodeContextProvider;
